import iframeResizerContent from 'iframe-resizer/js/iframeResizer.contentWindow.min';

export default {

  name: 'image-button-link-block',

  props: {
    block: {}
  },

  data () {
    return {
      overlay: false,
      iframeScrollTop: 0,
      iframeClientHeight: 0,
      iframeOffsetTop: 0
    };
  },

  computed: {
    internalLink: function () {
      return (this.block.data.href.includes('mercedes-benz.com') || this.block.data.href.startsWith('/'));
    }
  },

  methods: {
    showOverlay: function (event) {
      this.overlay = true;
      if ('parentIFrame' in window) {
        const overlayContents = document.getElementsByClassName('image-button-link-block-overlay-content');
        let overlayContentPosition = this.iframeScrollTop - this.iframeOffsetTop + this.iframeClientHeight / 2;
        overlayContents.forEach(element => element.style.top = `${overlayContentPosition}px`);
      }
    },

    getPageInfoIframe: function (iframeObject) {
      this.iframeScrollTop = iframeObject.scrollTop;
      this.iframeClientHeight = iframeObject.clientHeight;
      this.iframeOffsetTop = iframeObject.offsetTop;
    }
  },

  mounted () {
    if ('parentIFrame' in window) {
      parentIFrame.getPageInfo(
        (pageInfo) => this.getPageInfoIframe(pageInfo)
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/apps/booking/components/pageBuilder/pageBuilderBlock/types/imageButtonLinkBlock/ImageButtonLinkBlock.js